import React from 'react';

import { Grid, Typography } from '@material-ui/core';

import { TextField, ImageField, Step } from '../SteppedForm';

import rules from './rules';

const StepWatsdetails = (props) => {
  return (
    <Step
      id="watsdetails"
      title="Wheelchair Certification"
      skip={(formdata) => formdata.vehicles[props.state.vehicle_index].shape !== 'Wheelchair'}>
      <Grid container>
        <Grid item xs={12} lg={6}>
          <TextField id="wats_cred" label="Engineering Certificate #" required />
        </Grid>
        <Grid item xs={12} lg={6}>
          <TextField
            id="wheelchairs"
            label="# of Wheelchairs"
            type="number"
            valid={rules.numeric_bounded(1, 4)}
            required
          />
        </Grid>
      </Grid>
      <Typography variant="body1">
        Take a photo or scan your engineering certificate, then save it and upload the files using
        this file uploader.
      </Typography>
      <ImageField
        id="wats_image"
        label="Engineering Certificate"
        height={194}
        width={128}
        min_filesize={1000}
        max_filesize={5242880}
        acceptAll
        required
      />
    </Step>
  );
};

export default StepWatsdetails;
